import { render, staticRenderFns } from "./FilePreview.vue?vue&type=template&id=0452804b&scoped=true&"
import script from "./FilePreview.vue?vue&type=script&lang=js&"
export * from "./FilePreview.vue?vue&type=script&lang=js&"
import style0 from "./FilePreview.vue?vue&type=style&index=0&id=0452804b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0452804b",
  null
  
)

export default component.exports
import {QIcon,QBtn} from 'quasar'
component.options.components = Object.assign({QIcon,QBtn}, component.options.components || {})
